module.exports = __webpack_public_path__ + "static/media/Payments_White.880ca813.png";